<div class="highlight-card" [ngClass]="['theme-' + randomColor]" *ngIf="cardData">
  <div class="card-time" brtRoughText [type]="'circle'" [state]="current ? 'run' : 'stop'" *ngIf="cardData.time.length">{{cardData.time}} Uhr</div>

  <div class="highlight-card__title">

    <div class="highlight-card__title-background">
      <brt-svg-highlight [state]="current"></brt-svg-highlight>
    </div>
    <span [innerHTML]="cardData.title"></span>
  </div>
</div>
